var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1C9.87827 1 7.84344 1.92714 6.34315 3.57746C4.84285 5.22778 4 7.46609 4 9.8C4 11.8812 4.402 13.243 5.5 14.75L12 23L18.5 14.75C19.598 13.243 20 11.8812 20 9.8C20 7.46609 19.1571 5.22778 17.6569 3.57746C16.1566 1.92714 14.1217 1 12 1V1Z",
    stroke: "url(#paint0_linear_380_2847)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.1C13.6569 13.1 15 11.6225 15 9.8C15 7.97746 13.6569 6.5 12 6.5C10.3431 6.5 9 7.97746 9 9.8C9 11.6225 10.3431 13.1 12 13.1Z",
    stroke: "url(#paint1_linear_380_2847)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_380_2847",
    x1: 12.0037,
    y1: -9.93865,
    x2: 12.0037,
    y2: 27.8145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD86E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00902,
    stopColor: "#F6CD66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0391861,
    stopColor: "#DCAE4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0707524,
    stopColor: "#C8963B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1039,
    stopColor: "#B9852D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1397,
    stopColor: "#B17A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1829,
    stopColor: "#AE7723"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3046,
    stopColor: "#CE9E45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4244,
    stopColor: "#E8BF61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4902,
    stopColor: "#F2CB6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5439,
    stopColor: "#ECC466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6215,
    stopColor: "#DDB155"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7132,
    stopColor: "#C3923A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.778,
    stopColor: "#AE7723"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8178,
    stopColor: "#B27C27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8661,
    stopColor: "#BF8B33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9189,
    stopColor: "#D3A446"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9745,
    stopColor: "#F0C660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD86E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_380_2847",
    x1: 12.0014,
    y1: 3.2184,
    x2: 12.0014,
    y2: 14.5444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD86E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00902,
    stopColor: "#F6CD66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0391861,
    stopColor: "#DCAE4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0707524,
    stopColor: "#C8963B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1039,
    stopColor: "#B9852D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1397,
    stopColor: "#B17A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1829,
    stopColor: "#AE7723"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3046,
    stopColor: "#CE9E45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4244,
    stopColor: "#E8BF61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4902,
    stopColor: "#F2CB6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5439,
    stopColor: "#ECC466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6215,
    stopColor: "#DDB155"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7132,
    stopColor: "#C3923A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.778,
    stopColor: "#AE7723"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8178,
    stopColor: "#B27C27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8661,
    stopColor: "#BF8B33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9189,
    stopColor: "#D3A446"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9745,
    stopColor: "#F0C660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD86E"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPin);
export default __webpack_public_path__ + "static/media/location-pin.2e0935b437e6791989c1f33aaa791353.svg";
export { ForwardRef as ReactComponent };